import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import DataTableRepository from "../Repositories/DataTableRepository";

class DataTableBloc {
  rowtableChannel = new Subject();
  workUnitChannel = new Subject();
  listAtasanChannel = new Subject();
  inactiveChannel = new Subject();
  activeChannel = new Subject();
  generateChannel = new Subject();
  exportChannel = new Subject();
  verifikasiChannel = new Subject();
  detailBobotChannel = new Subject();

  listPositionChannel = new Subject();
  updatePositionChannel = new Subject();
  deleteTunsusChannel = new Subject();
  sendNotificationChannel = new Subject();
  clearPenilaianChannel = new Subject();

  repository = new DataTableRepository();

  constructor() {
    this.rowtableChannel.next({ status: apiResponse.INITIAL });
    this.workUnitChannel.next({ status: apiResponse.INITIAL });
    this.listAtasanChannel.next({ status: apiResponse.INITIAL });
    this.inactiveChannel.next({ status: apiResponse.INITIAL });
    this.activeChannel.next({ status: apiResponse.INITIAL });
    this.generateChannel.next({ status: apiResponse.INITIAL });
    this.verifikasiChannel.next({ status: apiResponse.INITIAL });
    this.detailBobotChannel.next({ status: apiResponse.INITIAL });
    this.exportChannel.next({ status: apiResponse.INITIAL });

    this.listPositionChannel.next({ status: apiResponse.INITIAL });
    this.updatePositionChannel.next({ status: apiResponse.INITIAL });
    this.deleteTunsusChannel.next({ status: apiResponse.INITIAL });
    this.sendNotificationChannel.next({ status: apiResponse.INITIAL });
    this.clearPenilaianChannel.next({ status: apiResponse.INITIAL });
  }

  fetchRowTable = async (query, cancelToken) => {
    this.rowtableChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchRowTable(query, cancelToken)
        .then((result) => {
          this.rowtableChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.rowtableChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchWorkUnit = async (query, cancelToken) => {
    this.workUnitChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchWorkUnit(query, cancelToken)
        .then((result) => {
          this.workUnitChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.workUnitChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchAtasan = async (query, cancelToken) => {
    this.listAtasanChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchAtasan(query, cancelToken)
        .then((result) => {
          this.listAtasanChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.listAtasanChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchInactive = async (query) => {
    this.inactiveChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchInactive(query)
        .then((result) => {
          this.inactiveChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.inactiveChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchActive = async (query) => {
    this.activeChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchActive(query)
        .then((result) => {
          this.activeChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.activeChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchRegenerate = async (query) => {
    try {
      this.generateChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchGenerate(query)
        .then((result) => {
          this.generateChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.generateChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "channel unsubscriber");
    }
  };

  fetchVerifikasi = async (query) => {
    try {
      this.verifikasiChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchVerifikasi(query)
        .then((result) => {
          this.verifikasiChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.verifikasiChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "channel unsubscriber");
    }
  };

  fetchVerifikasi;

  fetchExport = async (query) => {
    try {
      this.exportChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchExport(query)
        .then((result) => {
          this.exportChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.exportChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "channel unsubscriber");
    }
  };

  fetchBobot = async (query) => {
    try {
      this.detailBobotChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchBobot(query)
        .then((result) => {
          this.detailBobotChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.detailBobotChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "channel unsubscriber");
    }
  };

  fetchPosition = async (query, cancelToken) => {
    this.listPositionChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchPosition(query, cancelToken)
        .then((result) => {
          this.listPositionChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.listPositionChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  updatePosition = async (query) => {
    this.updatePositionChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .updatePosition(query)
        .then((result) => {
          this.updatePositionChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.updatePositionChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  sendNotification = async (query) => {
    try {
      this.sendNotificationChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .sendNotification(query)
        .then((result) => {
          this.sendNotificationChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.sendNotificationChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "channel unsubscriber");
    }
  };

  deleteTunsus = async (query) => {
    this.deleteTunsusChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .deleteTunsus(query)
        .then((result) => {
          this.deleteTunsusChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.deleteTunsusChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchClearSpecialAllowance = async (query) => {
    try {
      this.clearPenilaianChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchClearSpecialAllowance(query)
        .then((result) => {
          this.clearPenilaianChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.clearPenilaianChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };
}

export default DataTableBloc;
